import api from '../instance';

interface ISendFeedbackData {
  r: number;
  i: number;
  h: string;
  c?: string;
}

type TSendFeedbackResponse = {
  result: 'success' | 'error';
};

export default {
  sendFeedback: (data: ISendFeedbackData): Promise<TSendFeedbackResponse> =>
    api.post('survey', data),
};
